import { render, staticRenderFns } from "./advantage2.vue?vue&type=template&id=37a5f2bd&scoped=true&"
var script = {}
import style0 from "./advantage2.vue?vue&type=style&index=0&id=37a5f2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f2bd",
  null
  
)

export default component.exports